import { render } from "./Atencion_AtencionDet.vue?vue&type=template&id=0bf2ebc5&scoped=true"
import script from "./Atencion_AtencionDet.vue?vue&type=script&lang=js"
export * from "./Atencion_AtencionDet.vue?vue&type=script&lang=js"

import "@/assets/css/listaFiltrada02.css?vue&type=style&index=0&id=0bf2ebc5&scoped=true&lang=css"
import "./Atencion_AtencionDet.vue?vue&type=style&index=1&id=0bf2ebc5&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bf2ebc5"]])

export default __exports__